import { useContext } from 'react';
import { CloseCallback, LoaderContext, OpenCallback } from './loader.context';

export const useFullPageLoader = (): [OpenCallback, CloseCallback] => {
  const { open, close } = useContext(LoaderContext);
  return [open, close];
};
